<template>
    <div class="classify-templates">
        <div class="detail">
            <div class="item" :class="{ active: selectAll }" @click="changeClassify(all_item)">
                <img class="thumb" src="@/home/assets/pc/search/all-type.svg" alt="" />
                <span class="name">{{ $t("all") }}</span>
            </div>
            <div class="item" :class="{ active: item.active }" v-for="item in classify_list" :key="item.id" @click="changeClassify(item)">
                <img class="thumb" :src="item.img_url" alt="" />
                <span class="name">{{ item.name }}</span>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    @Component({})
    export default class ClassifyItem extends Vue {
        @Prop({
            type: Array,
            required: true,
        })
        classify_list;
        @Prop({
            type: Boolean,
            required: true,
        })
        selectAll;
        all_item = {
            id: -1,
            classId: 0,
            name: "全部",
            nameU: "all",
            local_templates: [],
        };
        changeClassify(item) {
            this.$emit("changeClassify", item);
        }
    }
</script>
<style lang="stylus" scoped>
    .classify-templates {
    	.detail {
    		display: flex;
    		flex-wrap: wrap;
    		align-items: center;

    		.item {
    			width: 198px;
    			padding: 8px 16px;
    			margin-bottom: 24px;
    			margin-right: 24px;
    			display: flex;
    			align-items: center;
    			box-shadow: 0 0 0 1px var(--borderTemplateColor);
    			border-radius: 8px;
    			cursor: default;

    			&:hover, &.active {
    				box-shadow: 0 0 0 1px #017fff;
    			}

    			&.active {
    				box-shadow: 0 0 0 2px #017fff;
    			}
    		}

    		.thumb {
    			width: 40px;
    			height: 40px;
    			margin-right: 16px;
    		}

    		.name {
    			color: var(--fontSearchColor);
    		}
    	}
    }
</style>
<i18n>
{
    "zh": {
      "all": "全部"
    },
    "en": {
      "all": "All"
    },
		"de": {
			"all": "Alle"
		},
		"fr": {
			"all": "Tout"
		},
		"es": {
			"all": "Todo"
		},
		"jp": {
			"all": "すべて"
		},
		"pt": {
			"all": "Todos"
		},
		"it": {
			"all": "tutto"
		},
		"tw": {
			"all": "全部"
		},
		"kr": {
			"all": "모두"
		},
		"id": {
			"all": "Beranda"
		},
		"ru": {
			"all": "Главная"
		}
}
</i18n>
